/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import Header1 from "ui/kit/typography/Header1";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {LibraryDetailBody_piece$data} from "./__generated__/LibraryDetailBody_piece.graphql";
import {Link} from "react-router-dom";
import {PieceEdit, PieceOriginalImages, PieceSettings, PlayPiece} from "constants/paths";
import Button from "ui/kit/buttons/Button";
import {faEdit, faEye, faGear, faPlay} from "@fortawesome/free-solid-svg-icons";

interface Props {
    piece: LibraryDetailBody_piece$data
}

const LibraryDetailBody: React.FC<Props> = ({piece}) => {
    return (
        <div>
            <Header1>{piece.name || "Unnamed Music Piece"}</Header1>
            {piece.status !== "COMPLETE" && <Link to={PieceEdit(piece.id)}>
                <Button title={"Finish Editing Piece"} icon={faEdit}/>
            </Link>}
            {piece.status === "COMPLETE" && <Link to={PlayPiece(piece.id)}>
                <Button title={"Play Piece"} icon={faPlay}/>
            </Link>}
            <Link to={PieceOriginalImages(piece.id)}>
                <Button title={"View Original Images"} icon={faEye}/>
            </Link>
            <Link to={PieceSettings(piece.id)}>
                <Button title={"Settings"} icon={faGear}/>
            </Link>
        </div>
    )
}

export default createFragmentContainer(LibraryDetailBody, {
    piece: graphql`
    fragment LibraryDetailBody_piece on MusicPiece {
        id
        name
        status
    }
    `
});